module.exports = __webpack_public_path__ + "static/media/Sucursal.426e90b1.svg";